var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPurpleDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 8,
    viewBox: "0 0 11 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.57792 5.20273L5.58571 5.21052L5.59349 5.20273L9.64172 1.1545C9.75124 1.04507 9.8972 0.984654 10.053 0.984654C10.2088 0.984654 10.3549 1.04507 10.4643 1.1545L10.8193 1.50953L10.8193 1.50954C10.9288 1.61896 10.989 1.76499 10.989 1.92081C10.989 2.07663 10.9287 2.22258 10.8193 2.3321L5.9984 7.15284L5.99839 7.15285C5.88915 7.26226 5.74321 7.32233 5.58738 7.32233C5.42827 7.32233 5.28242 7.26224 5.17302 7.15284L0.347602 2.32751C0.120966 2.10079 0.120966 1.73176 0.347603 1.50504L0.702719 1.14984C0.812238 1.04049 0.958108 0.980163 1.11392 0.980163C1.26982 0.980163 1.41577 1.04049 1.5252 1.14983L5.57792 5.20273Z",
    fill: "#673E9B",
    stroke: "#673E9B",
    strokeWidth: 0.022019
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurpleDown);
export default __webpack_public_path__ + "static/media/purple-down.963dc022ad55c8aecdb512ac48189fbd.svg";
export { ForwardRef as ReactComponent };